export default __webpack_public_path__ + "static/media/QrBack.9cdbcca1.png";